export let WaveType;
(function (WaveType) {
  WaveType["Error"] = "ErrorWave";
  WaveType["LowOrange"] = "LowOrangeWave";
  WaveType["Orange"] = "OrangeWave";
})(WaveType || (WaveType = {}));
export let LayoutType;
(function (LayoutType) {
  LayoutType["CentredStep"] = "CentredStep";
  LayoutType["FramedCentredStep"] = "FramedCentredStep";
  LayoutType["FramedCentredModalStep"] = "FramedCentredModalStep";
  LayoutType["TwoColumn"] = "TwoColumn";
  LayoutType["LeftAlignedTwoColumn"] = "LeftAlignedTwoColumn";
  LayoutType["LeftAligned"] = "LeftAligned";
  LayoutType["SidePanel"] = "SidePanel";
  LayoutType["ThreeColumn"] = "ThreeColumn";
})(LayoutType || (LayoutType = {}));
export let DecorativeBgComponent;
(function (DecorativeBgComponent) {
  DecorativeBgComponent["Circles"] = "Circles";
  DecorativeBgComponent["CirclesWithStars"] = "CirclesWithStars";
})(DecorativeBgComponent || (DecorativeBgComponent = {}));